import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';
export class LGNetCastConfigs extends AbstractSTVPlatformConfig {
    constructor(params) {
        super(params);
        this.configs.properties.device = EmbedDevice.LG_NETCAST;
    }
}
